<div class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close"><span
                        aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Recording Debug Mode</h4>
            </div>
            <div class="modal-body">
                <div class="modal-message">
                    <span>
                            WCPM Target: {{contentCursor.selection.metaData.wpmGoal}}
                    </span>
                </div>
                <div class="modal-message" class="block">
                    <label for="desiredWCPM" class="col-form-label">Desired WCPM:</label>
                    <input maxlength="5" size="5" type="text" [(ngModel)]="simulatedWCPM"
                           id="desiredWCPM">
                </div>


            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-blueglass btn-lg"
                        style="display: block; margin: 0 auto;"
                        [disabled]="!wcpmValid()" (click)="startDebugRecording()"
                        data-dismiss="modal"
                        aria-label="Start">Start
                </button>

            </div>
        </div>
    </div>
</div>

<div class="modal-backdrop fade in" *ngIf="activateModal"></div>
